module.exports = __webpack_public_path__ + "static/media/hinted-MaisonNeue-DemiItalic.a1265426.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/maison/hinted-MaisonNeue-DemiItalic.woff
// module id = 236
// module chunks = 0